export class GenericTableField {
	public label: string;
	public code: string;
	public type: string;
	public style: string;
	public value: string;

	constructor(){
	}

	getLabel(){
		return this.label;
	};

	getCode(){
		return this.code;
	};

	getType(){
		return this.type;
	};

	getStyle(){
		return this.style;
	};

	getValue(){
		return this.value;
	};

	setAllValue(label: string, code: string, type: string, style: string){
		this.label = label;
		this.code = code;
		this.type = type;
		this.style = style;
		this.value = "";
	}

	setValue(value: string){
		this.value = value;
	}
}

export class GenericTableFields {
	header: GenericTableField[] = [];
	footer: GenericTableField[] = [];

	constructor(){
	}

	getHeader(){
		return this.header;
	}

	getFooter(){
		if(!this.footer){
			this.generateFooterRow();
		}
		return this.footer;
	}

	generateFooterRow(valueArray: any = null){
		this.footer = [];
		let totalField: GenericTableField;
		for(let headerField of this.header){
			totalField = new GenericTableField();
			totalField.setAllValue(headerField.getLabel(), headerField.getCode(), headerField.getType(), headerField.getStyle());
			if(valueArray){
				totalField.setValue(valueArray.getFieldString(headerField.getCode()));
			}
			this.footer.push(totalField);
		}
    }
}
